/* eslint-disable
    one-var
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// @ts-expect-error
import CharPickerData from 'char-picker-data';
import React from 'react';
import {debounce} from 'ts-debounce';
import _ from 'underscore';

import CharListing, {COMMON_SYMBOLS} from 'notebook/mediocre/symbols/CharListing';
import CharPreview from 'notebook/mediocre/symbols/CharPreview';
import UniCloud from 'notebook/mediocre/symbols/UniCloud';
import notifications from 'notifications';
import getTestProps from 'test/lib/cypress/getTestProps';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';

interface CharPickerDataInterface {
  categories: Array<string>;
  subcategories: Array<Array<string>>;
}

const CHAR_PICKER_DATA: CharPickerDataInterface = new CharPickerData() as unknown as CharPickerDataInterface;
const INITIAL_CATEGORY = 0;
const INITIAL_SUBCATEGORY = CharListing.COMMON_SYMBOLS_SUBCATEGORY;

function sortSearchResults(results: Array<string>): Array<string> {
  return _.sortBy(results, (result: string) => (COMMON_SYMBOLS.includes(result) ? -1 : 1));
}

interface FullCharPreviewProps {
  char: string;
}

class FullCharPreview extends React.PureComponent<FullCharPreviewProps> {
  override render(): JSX.Element {
    return (
      <UniCloud char={this.props.char}>
        {({name, codePoint}) => (
          <div
            {...getTestProps({component: 'FullCharPreview', element: 'root'})}
            className="fullCharPreview u-small-spacing-top u-small-padding"
          >
            <div className="fullCharPreview-char selectable">
              {CharPreview.previewableChar(this.props.char)}
            </div>
            <div>{name || '\u00A0'}</div>
            <div className="u-small-text faded">{codePoint}</div>
          </div>
        )}
      </UniCloud>
    );
  }
}

interface UnicodeCharacterChooserProps {
  char: string | null;
  selectChar: (args: {char: string; insert: boolean}) => void;
}

interface UnicodeCharacterChooserState {
  searchQuery: string;
  searchResults: Array<string>;
  category: number;
  subCategory: number;
}

class UnicodeCharacterChooser extends React.PureComponent<
  UnicodeCharacterChooserProps,
  UnicodeCharacterChooserState
> {
  private _isMounted: boolean = false;
  private searchInputRef = React.createRef<HTMLInputElement>();

  override state: UnicodeCharacterChooserState = {
    searchQuery: '',
    searchResults: [],
    category: INITIAL_CATEGORY,
    subCategory: INITIAL_SUBCATEGORY,
  };

  performSearch = debounce((searchQuery: string) => {
    if (this._isMounted && searchQuery.length === 0) {
      this.clearSearch();
      return;
    }
    UniCloud.searchChars(searchQuery)
      .catch(() => {
        notifications.error('An error occurred while searching.', {id: 'unicode-character-chooser'});
        return [];
      })
      .then((results) => {
        if (this._isMounted && this.state.searchQuery === searchQuery) {
          const searchResults = sortSearchResults(results);
          this.setState({searchResults}, () => {
            if (searchResults.length === 0) {
              return;
            }
            const char = searchResults[0];
            this.props.selectChar({char, insert: false});
          });
        }
      });
  }, 100);

  handleQueryChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const searchQuery = e.target.value;
    this.setState({searchQuery});
    this.performSearch(searchQuery);
  };

  handleCategoryChange = (e: React.ChangeEvent<HTMLSelectElement>): void => {
    const category = parseInt(e.target.value, 10);
    const newSubCategory = category === 0 ? CharListing.COMMON_SYMBOLS_SUBCATEGORY : 0;
    this.setState({category, subCategory: newSubCategory});
  };

  handleSubCategoryChange = (e: React.ChangeEvent<HTMLSelectElement>): void => {
    const subCategory = parseInt(e.target.value, 10);
    this.setState({subCategory});
  };

  clearSearch = (): void => {
    this.setState({searchQuery: '', searchResults: []});
  };

  override componentDidMount(): void {
    this._isMounted = true;
    _.defer(() => {
      if (this._isMounted && this.searchInputRef.current) {
        this.searchInputRef.current.focus();
      }
    });
  }

  override componentWillUnmount(): void {
    this._isMounted = false;
  }

  override render(): JSX.Element {
    let category: number, subCategory: number;
    return (
      <div>
        <Row>
          <Col sm={7}>
            <div>
              {this.state.searchQuery.length ? (
                <a onClick={this.clearSearch} className="u-input-line-height">
                  Clear search
                </a>
              ) : (
                [
                  <select
                    key="select-category"
                    className="u-inline-form-input-sm"
                    value={this.state.category}
                    onChange={this.handleCategoryChange}
                  >
                    {(() => {
                      const result = [];
                      for (category = 0; category < CHAR_PICKER_DATA.categories.length; category++) {
                        const categoryName = CHAR_PICKER_DATA.categories[category];
                        result.push(
                          <option key={category} value={category}>
                            {categoryName}
                          </option>
                        );
                      }
                      return result;
                    })()}
                  </select>,
                  <select
                    key="select-subcategory"
                    className="u-inline-form-input u-small-spacing-left"
                    value={this.state.subCategory}
                    onChange={this.handleSubCategoryChange}
                  >
                    {this.state.category === 0 ? (
                      <option
                        key={CharListing.COMMON_SYMBOLS_SUBCATEGORY}
                        value={CharListing.COMMON_SYMBOLS_SUBCATEGORY}
                      >
                        Common Symbols
                      </option>
                    ) : undefined}
                    {(() => {
                      const result1 = [];
                      for (
                        subCategory = 0;
                        subCategory < CHAR_PICKER_DATA.subcategories[this.state.category].length;
                        subCategory++
                      ) {
                        const subCategoryName =
                          CHAR_PICKER_DATA.subcategories[this.state.category][subCategory];
                        result1.push(
                          <option key={subCategory} value={subCategory}>
                            {subCategoryName}
                          </option>
                        );
                      }
                      return result1;
                    })()}
                  </select>,
                ]
              )}
            </div>
            <CharListing
              charPickerData={CHAR_PICKER_DATA}
              searchQuery={this.state.searchQuery}
              searchResults={this.state.searchResults}
              category={this.state.category}
              subCategory={this.state.subCategory}
              selectChar={this.props.selectChar}
            />
          </Col>
          <Col sm={5}>
            <input
              type="text"
              ref={this.searchInputRef}
              placeholder="Search for a symbol, e.g. omega"
              value={this.state.searchQuery}
              onChange={this.handleQueryChange}
            />
            {this.props.char != null ? <FullCharPreview char={this.props.char} /> : undefined}
          </Col>
        </Row>
      </div>
    );
  }
}

export default UnicodeCharacterChooser;
